import TopHeader from "../../../../components/general/TopHeader";

export default function Sensor (){
    return(
        <>
        <TopHeader/>
        <p>no data found</p>
        </>
    )
}